<!--
  @description 流程管理-云资源申请 v2.0.2 修改为工单申请
  @author xiehan
  @date 2018/12/25
-->
<template>
  <div class="cloudApplication__content">
    <div class="mb-base">
      <el-radio-group v-model="type" @change="typeChange">
        <el-radio-button v-for="(value, key) in select_type" :label="key" :key="key">{{ value }}</el-radio-button>
      </el-radio-group>
    </div>
    <el-row>
      <el-button v-show="processList.length > 0"
        v-for="item in processList"
        :key="item.id" type="primary"
        size="large"
        plain
        @click="jumpOrder(item)">{{item.name}}</el-button>
      <div v-show="processList.length === 0" v-text="$t('common.noData')" style="text-align: center;"></div>
    </el-row>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'

  export default {
    mixins: [dic],
    data () {
      return {
        processList: [],
        select_type: {},
        type: ''
      }
    },
    methods: {
      async preInitDic () {
        await Promise.all([
          this.dGetDictionaryByCode('orderType')
        ])
        this.select_type = { ...this.dDictionary.orderType }
        this.type = this.type || Object.keys(this.select_type)[0]
        this.typeChange(this.type)
      },
      typeChange (val) {
        this.initProcess(val)
      },
      initProcess (type) {
        resApplicationBiz.getAll({ type: type }).then(data => {
          this.processList = data
        })
      },
      jumpOrder (item) {
        let queryObj = {
          processDefinitionId: item.processDefinitionId,
          templateId: item.templateId
        }
        switch (item.processDefinitionId) {
          // 新开机
          case 'BootupRequestProcess':
            this.$router.push({ name: 'bootUpRequest', query: queryObj })
            break
          // PAAS初始化
          case 'PaasInitRequestProcess':
            this.$router.push({ name: 'paasInitRequest', query: queryObj })
            break
          // 业务上线
          case 'ServiceGoLiveRequestProcess':
            this.$router.push({ name: 'serviceRequest', query: queryObj })
            break
          // 关机
          case 'ShutdownRequestProcess':
            this.$router.push({ name: 'shutdownRequest', query: queryObj })
            break
          // 通用模板
          case 'CommonRequestProcess':
            this.$router.push({ name: 'commonRequest', query: queryObj })
            break
          // 主机与数据库权限
          case 'DBPermissionRequestProcess':
            this.$router.push({ name: 'dbPermissionRequest', query: queryObj })
            break
          // 关闭权限
          case 'ClosePermissionProcess':
            this.$router.push({ name: 'closePermissionRequest', query: queryObj })
            break
          // 回收权限
          case 'RevokePermissionProcess':
            this.$router.push({ name: 'revokeRequest', query: queryObj })
            break
          default:
            this.$message.error(this.$t('cloudApplication.processTmlErr'))
        }
      }
    },
    mounted () {
      this.preInitDic()
    }
  }
</script>

<style scoped>
  .el-button--primary.is-plain{
    height: 80px;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 20px;
    margin-right: 16px;
    margin-left: 0;
  }
  .mb-base{
    margin-bottom: 14px;
  }
</style>